import utils from "../../../utils/utils";

export default {
    async fetchWorkspaceAccounts(context) {
        const response = await utils.utility.fetch("api/editor/getallworkspaceactiveaccounts", "GET", null, null);
        
        context.commit("setWorkspaceAccounts", response.data);
    },
    async fetchWorkspaceAgents(context) {
        const response = await utils.utility.fetch("api/editor/GetAllWorkspaceUsers", "GET", null, null);
        
        context.commit("setWorkspaceAgents", response.data);
    },
    async fetchWorkspaceQueues(context) {
        const response = await utils.utility.fetch("api/workspace/getworkspacequeues", "GET", null, null);

        context.commit("setWorkspaceQueues", response.data);
    },
    async fetchWorkspaceIsPrivateSend(context) {
        const response = await utils.utility.fetch("api/workspace/getworkspaceisprivatesend", "GET", null, null);

        context.commit("setWorkspaceIsPrivateSend", response.data);
    }
}